<div *ngIf="loading; else loaded">Loading...</div>

<ng-template #loaded>
  <div *ngIf="personStaffGroupAudits && personStaffGroupAudits.length > 0; else noAudits">
    <sd-portal-audit-detail-list [audits]="personStaffGroupAudits" (nextPage)="onNextPage()">
    </sd-portal-audit-detail-list>
  </div>
  <ng-template #noAudits> No Staff Group audits </ng-template>
</ng-template>
